import React, { useEffect, useState } from 'react';
import $ from 'jquery';
import { getSetupGuideUrl, isSetupGuideUrl, getApiOnboardingStatusCountUrl } from '../../utilities/urlHelper';

const SetupGuideSidebarLink = () => {
    const [percentageComplete, setPercentageComplete] = useState('');

    useEffect(() => {
        $.get(getApiOnboardingStatusCountUrl())
            .done(({ completedSteps, totalSteps }) => setPercentageComplete(Math.floor(completedSteps / totalSteps * 100)));
    }, []);

    const selectedClass = isSetupGuideUrl() ? 'left-nav__selected' : '';

    return (
        <a href={getSetupGuideUrl()} className={`left-nav__item left-nav__static-link  ${selectedClass}`}>
            <img className="left-nav__icon" height="22" width="22" src="/img/icons/setup-guide-icon.svg" style={{ backgroundColor: '#F28202' }} alt="Setup guide icon" />
            <span className="flex-auto left-nav__text">Setup guide</span>
            <div id="sidebar-content-number" className="pie" style={{ '--p': percentageComplete }} title={`${percentageComplete}% complete`} />
        </a>
    );
};

export default SetupGuideSidebarLink;
